import { getActionTypes, generateDefaultState } from '../../../utils/reduxHelper';
import storage from '../../../utils/storage';

const authActions = getActionTypes('auth', ['CREATE']);

const userActions = getActionTypes('user', ['CREATE', 'GET_ALL', 'GET'])

export const actions = {
    ...authActions,
    ...userActions
}

const initialUserState = {
    ...generateDefaultState('user', [
        'GET_ALL',
        'GET',
        'CREATE'
    ])
};

export const initialAuthState = {
    userName: '',
    authToken: storage.getToken() || undefined,
    error: undefined,
    ...initialUserState
};
